import script from "./MerchantQualificationDialog.vue?vue&type=script&setup=true&lang=ts&name=MerchantQualificationDialog"
export * from "./MerchantQualificationDialog.vue?vue&type=script&setup=true&lang=ts&name=MerchantQualificationDialog"

import "./MerchantQualificationDialog.vue?vue&type=style&index=0&id=e033fe78&lang=stylus&scoped=true"

import exportComponent from "/www/wwwroot/home/v-admin/node_modules/.store/vue-loader@16.8.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e033fe78"]])

export default __exports__